module.exports = __webpack_public_path__ + "static/media/3-SanchezRamos(1).dff5ac0f.png";